import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { IonPopover } from '@ionic/angular';

@Component({
  selector: 'ui-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit {
  @Input() label: string | undefined;
  @Input() placeholder: string | undefined;
  @Input() selectedDate: string | undefined;
  @Input() readonly = false;

  @Output() dateChange = new EventEmitter<string>();

  @ViewChild(IonPopover) popover: IonPopover | undefined;

  dateId!: string;

  ngOnInit(): void {
    this.dateId = this.generateUniqueId();
  }

  get formattedDate(): string {
    return this.selectedDate
      ? new Date(this.selectedDate).toLocaleDateString('it-IT', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
      : '';
  }

  closeDatePicker() {
    this.popover?.dismiss();
  }

  onDateChange(event: any) {
    this.selectedDate = event.detail.value;
    this.dateChange.emit(this.selectedDate);
    this.closeDatePicker();
  }

  generateUniqueId(): string {
    return 'date-' + Math.random().toString(36).substr(2, 9);
  }
}
